var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-1 col-md-3 col-xl-4 reportModelSep" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-10 col-md-6 col-xl-4 mx-auto" },
        [
          _c(
            "Trapmodal",
            {
              attrs: {
                group: "downlaod-report-modal",
                id: "downlaod-report-modal-id"
              }
            },
            [
              _c("div", { staticClass: "card border border-0 pb-0 shadow" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("div", { staticClass: "text-white" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-10 col-md-10 col-lg-10 float-left px-0"
                      },
                      [
                        _vm._v(
                          "\n                    Download: Full Daily Activity Report\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-right col-sm-2 col-md-2 col-lg-2 float-left pr-0"
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "javascript:void(0)",
                              id: "report-modal-close"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.$emit("displayModal")
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fas fa-times-circle cursorBox"
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-lg-10 col-xl-12" },
                      [
                        _c(
                          "fieldset",
                          {
                            staticClass: "form-group",
                            attrs: { id: "__BVID__73" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { tabindex: "-1", role: "group" } },
                              [
                                _c("input-product-type", {
                                  attrs: { insuranceType: _vm.insuranceType }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-12 col-lg-10 col-xl-12 activity-date-picker"
                      },
                      [
                        _c(
                          "fieldset",
                          {
                            staticClass: "form-group",
                            attrs: { id: "__BVID__73" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { tabindex: "-1", role: "group" } },
                              [
                                _c("label", { attrs: { for: "daterange" } }, [
                                  _vm._v(
                                    "\n                            Select a Date Range:"
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "pt-sub-text" }, [
                                    _vm._v(
                                      "This report's data only goes to the past 90 days. Refer to the FTP Transaction Report for more details."
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "p-0 col-sm-4 col-lg-4 col-xl-4 date-pickers"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-container from-picker"
                                      },
                                      [
                                        _c("form-block", {
                                          attrs: {
                                            formdata: _vm.datePickerFrom
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-container to-picker"
                                      },
                                      [
                                        _c("form-block", {
                                          attrs: { formdata: _vm.datePickerTo }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "row text-center" }, [
                    _c("div", { staticClass: "col-sm-12" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary download-template-btn",
                          on: {
                            click: function($event) {
                              return _vm.downloadDailyActivityReport()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-file-download" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-1" }, [
                            _vm._v("Download")
                          ]),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.$store.getters.getInlineLoader,
                                  expression: "$store.getters.getInlineLoader"
                                }
                              ],
                              staticClass: "ml-3"
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-circle-o-notch fa-spin"
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-link text-muted",
                          attrs: { title: "Cancel Download" },
                          on: {
                            click: function($event) {
                              return _vm.cancelDailyActivityReport()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                      Cancel Download\n                    "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-1 col-md-3 col-xl-4 reportModelSep" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c2b8df7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c2b8df7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/ReportsDownload.vue
// module id = null
// module chunks = 